import { noop, partial } from 'es-toolkit';
import { transformArtworkUrl, transformNowPlaying, transformTune, transformUnwrappedStreams, } from './transforms';
export class StreamsService {
    #requestClient;
    #storeClient;
    constructor(requestClient, storeClient) {
        this.#requestClient = requestClient;
        this.#storeClient = storeClient;
    }
    async get(options) {
        const { domains, forceHttpsStreams } = this.#storeClient.options;
        const { id: guideId, itemToken } = options.params;
        const adswizzListenerId = window.com_adswizz_synchro_getListenerId?.();
        const tunePromise = this.#requestClient.fetch({
            url: `${domains.opml}/Tune.ashx`,
            params: {
                ...options.params,
                ...(adswizzListenerId && { adswizzListenerId }),
            },
        });
        const [streams, nowPlaying] = await Promise.all([
            tunePromise,
            options.requestNowPlaying ? this.getNowPlaying({ guideId, itemToken }) : null,
        ]);
        return {
            ...transformTune({
                streams,
                forceHttpsStreams,
                tuneInPlaylistHandler: this.#unwrapPlaylist,
                playbackPositionOverride: options.playbackPositionOverride,
            }),
            nowPlaying,
        };
    }
    getNowPlaying(options) {
        const { guideId, token, itemToken } = options;
        const { domains } = this.#storeClient.options;
        const transform = partial(transformNowPlaying, partial.placeholder, guideId);
        return this.#requestClient.fetch({
            url: `${domains.feed}/profiles/${guideId}/nowPlaying`,
            params: { token, itemToken },
            transform,
        });
    }
    getArtworkUrl(artist, title) {
        const { domains } = this.#storeClient.options;
        return this.#requestClient
            .fetch({
            url: `${domains.opml}/Songlookup.ashx`,
            params: { artist, title },
            transform: transformArtworkUrl,
        })
            .catch(noop);
    }
    #unwrapPlaylist = async (url) => {
        const { forceHttpsStreams } = this.#storeClient.options;
        const urlObj = new URL(url);
        urlObj.searchParams.set('render', 'json');
        const { streams } = await this.#requestClient.fetch({
            url: urlObj.toString(),
            skipUrlTransform: true,
        });
        return transformUnwrappedStreams({ streams, forceHttpsStreams });
    };
}
